module.exports = __webpack_public_path__ + "static/media/v49.cb76a30e.mp4";